var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bold-Outline",
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pen",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.914213562,13 L2.91421356,15 L15.5,15 L15.5,11 L2.91421356,11 L0.914213562,13 Z M2.5,9 L16.5,9 C17.0522847,9 17.5,9.44771525 17.5,10 L17.5,16 C17.5,16.5522847 17.0522847,17 16.5,17 L2.5,17 C2.23478351,17 1.9804296,16.8946432 1.79289322,16.7071068 L-1.20710678,13.7071068 C-1.59763107,13.3165825 -1.59763107,12.6834175 -1.20710678,12.2928932 L1.79289322,9.29289322 C1.9804296,9.10535684 2.23478351,9 2.5,9 Z M17.5,15 L21.5,15 L21.5,11 L17.5,11 L17.5,15 Z M16.5,9 L22.5,9 C23.0522847,9 23.5,9.44771525 23.5,10 L23.5,16 C23.5,16.5522847 23.0522847,17 22.5,17 L16.5,17 C15.9477153,17 15.5,16.5522847 15.5,16 L15.5,10 C15.5,9.44771525 15.9477153,9 16.5,9 Z",
    id: "shape",
    transform: "translate(11.000000, 13.000000) rotate(-45.000000) translate(-11.000000, -13.000000) "
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.41f5dbed640f9c5ce5ee40b1d5115c73.svg";
export { ForwardRef as ReactComponent };